'use client';
import { motion } from 'framer-motion';
import type { XYChartLinePoint } from './xychart-types';
export interface XYChartLineEndpointDotProps {
    point: XYChartLinePoint | null;
    visible: boolean;
    color: string;
    seriesOpacity: number;
    seriesLabel: string;
}
export function XYChartLineEndpointDot({ point, visible, color, seriesOpacity, seriesLabel, }: XYChartLineEndpointDotProps) {
    if (!visible || !point)
        return null;
    return (
    <motion.circle cx={point.x} cy={point.y} r={3} fill={color} initial={{ opacity: 0 }} animate={{ opacity: seriesOpacity }} transition={{
            duration: 0.3,
            delay: 0.6,
            ease: 'easeOut',
        }} style={{ pointerEvents: 'none' }}/>
    );
}
